import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import CookieBanner from "./components/CookieBanner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import ComeFunziona from "./pages/ComeFunziona";
import Napoli from "./pages/Napoli";
import Caserta from "./pages/Caserta";
import Roma from "./pages/Roma";
import Contatti from "./pages/Contatti";
import TerminiServizio from "./pages/TerminiServizio";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Admin from "./pages/Admin";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <Routes>
          {/* Admin Route (no header/footer) */}
          <Route path="/admin" element={<Admin />} />
          
          {/* Public Routes (with header/footer) */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/chi-siamo" element={<ChiSiamo />} />
                  <Route path="/come-funziona" element={<ComeFunziona />} />
                  <Route path="/agenzia-matrimoniale-napoli" element={<Napoli />} />
                  <Route path="/agenzia-matrimoniale-caserta" element={<Caserta />} />
                  <Route path="/agenzia-matrimoniale-roma" element={<Roma />} />
                  <Route path="/contatti" element={<Contatti />} />
                  <Route path="/termini-servizio" element={<TerminiServizio />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
      <CookieBanner />
      </div>
    </HelmetProvider>
  );
}

export default App;
